module.exports = __webpack_public_path__ + "static/homepage-desktop-media-ingenuity-c414c2c97b1a7894139c8ab86d0e0c12.jpg";